// src/resources/sections/cronConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const CRON_CONFIG: ResourceConfig[] = [
  {
    name: "v_job",
    label: "Job",
    schema: "cron",
    readOnly: true,
    fields: [
      {
        source: "jobid",
        label: "jobid",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "schedule",
        label: "schedule",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "command",
        label: "command",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "nodename",
        label: "nodename",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "database",
        label: "database",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "username",
        label: "username",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "active",
        label: "active",
        kind: "boolean",
        list: true,
        form: true,
      },
      {
        source: "jobname",
        label: "jobname",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["command", "jobname", "active"],
  },
  {
    name: "v_job_run_details",
    label: "Job Run Details",
    schema: "cron",
    readOnly: true,
    fields: [
      {
        source: "jobid",
        label: "jobid",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "runid",
        label: "runid",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "job_pid",
        label: "job_pid",
        kind: "number",
        list: true,
        form: true,
      },
      {
        source: "status",
        label: "status",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "command",
        label: "command",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "nodename",
        label: "nodename",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "database",
        label: "database",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "username",
        label: "username",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "return_message",
        label: "return_message",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "start_time",
        label: "start_time",
        kind: "date",
        list: true,
        form: true,
      },
      {
        source: "end_time",
        label: "end_time",
        kind: "date",
        list: true,
        form: true,
      },
    ],
    searchFields: ["command", "jobid", "return_message", "status"],
  },
];
